import React from "react";
import { Props } from "./types";

function FlashReportIcon(props: Props) {
  return (
    <svg className={props.className} viewBox="0 0 23.914 31.463">
      <path
        d="M-1953.6,17982.465h-18.878a2.522,2.522,0,0,1-2.518-2.518v-26.428a2.522,2.522,0,0,1,2.518-2.518h10.3v6.291a3.541,3.541,0,0,0,3.538,3.537h7.555v19.117A2.522,2.522,0,0,1-1953.6,17982.465Zm-15.981-5.334h0V17979h13.083v-1.869Zm0-8.414v0l6.539,6.545,6.544-6.545h-3.741v-5.605h-5.605v5.605h-3.737Zm17.989-11.014h-6.165a1.289,1.289,0,0,1-1.286-1.287v-4.914a.5.5,0,0,1,.5-.5,2.168,2.168,0,0,1,1.395.5l5.172,4.311a2,2,0,0,1,.722,1.553A.335.335,0,0,1-1951.595,17957.7Z"
        transform="translate(1974.999 -17951.002)"
      />
    </svg>
  );
}

export { FlashReportIcon };
